import React, { useState, useEffect, useRef } from "react";
import { useForm } from "react-hook-form"; 
import * as yup from "yup";
import Arrow from "../../../../assets/images/arrow.png";
import { useTranslation } from "react-i18next";
import CustomInput from "../../../CustomComponents/FormInputs";
import Card from "../../../CustomComponents/Card";
import addLineBreaks, { displayErrorMessage, handleAmountInputLimitTo2decimal, retrieveData } from "../../../../utils";
import {
  GetApiHeadersWithOutBearer,
  GetRequest,
  PostRequest,
} from "../../../../network/NetworkUtils";

import { useSelector } from "react-redux";
import Loader from "../../../CustomComponents/Loader";
import {
  appTheme,
  generateRegexExpression, 
} from "../../../../helpers/utils/Utils";
import { fetchConfigarationData } from "../../../../helpers/utils/Utils";
import { useKeyDown } from "../../../../hooks/useKeyDown";
import { SMI_ONE_CARD_VALIDATE, STATUS_SUCCESS_CODE } from "../../../../network/URLConstants";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch } from 'react-redux';
const appConfigData = await fetchConfigarationData();
// const appConfigData = await fetchConfigarationData();
const SmiOneExpirationDateAndLastDigitCard = ({locateMyCardDetails, handleLastdigitNo}) => {
  const { t } = useTranslation();
  const appConfigData = useSelector((state) => state.appConfigData); 
  const SubTittleStylesModal =
    "font-serif-pro lg:text-[31px] md:text-[26px] sm:text-[22px] text-[25px] lg:leading-[38px] md:leading-[33px] sm:leading-[29px] leading-[31px] font-normal sm:text-[var(--text-clr-secondary)] text-[var(--text-clr-secondary3)]";
  const userId = useSelector((state) => state.userId);
  const [isLoading, setIsLoading] = useState(false); 
  const [policyCriteria, setPolicyCriteria] = useState({}); 
  const [isLastDigitEntered, setIsLastDigitEntered] = useState(false); 
  const signUpkudzuPlusTrue = useSelector((state) => state.isSignUpKudzuplusTrue);
  const appThemeData = appTheme(signUpkudzuPlusTrue); 
  const isFromSmiOne = useSelector((state) => state.fromSmiOne);
  const [lastDigit, setLastDigit] = useState()
  const [errorMessage, setErrorMessage] = useState('');
  const lastDigitRef = useRef(null);
  const smiOneUserId = useSelector(state => state.smiOneKudzuResponseData.userId);
  const lastDigitNumber = useSelector(state => state.smiOneLastDigitCardNo);
  const dispatch = useDispatch();
 
  const schema = yup.object().shape({
    lastDigit: yup
      .string()
      .required("Card Number is required") 
    
  });
  const validationSchema = yup.object().shape({
    lastDigitNo : yup.string().required('Last 4 Digits Number required'),
  
  });
  const { register, formState: { errors }, setError, setValue, clearErrors, getValues } = useForm({
    resolver: yupResolver(validationSchema),
  });


  const handleLastDigitSabmit = async () => {
      setIsLoading(true);
      const deviceId = await retrieveData("updatedDeviceId");
      let headers = await GetApiHeadersWithOutBearer(deviceId);
      const object = {
      "Last4Digits": lastDigitNumber,
      "applicationId": appConfigData.CLIENT_ID
      }
      const url = SMI_ONE_CARD_VALIDATE(smiOneUserId, appConfigData.CLIENT_ID);
      var response = await PostRequest(url, object, headers);
  
      var responseObj = JSON.parse(response);
      if (responseObj.ResponseCode === STATUS_SUCCESS_CODE) {
        handleLastdigitNo()
        setIsLoading(false);
      }else{
        var arrMessages = responseObj.Messages;
          var messageObject = arrMessages[0];
          const message = messageObject.DisplayText;
        setIsLoading(false);
        setErrorMessage(message)
      }
  }; 
  useEffect(() => {
    if (lastDigitNumber && lastDigitNumber.length === 4) {
      setIsLastDigitEntered(true);
    } else {
      setIsLastDigitEntered(false);
    }
  }, [lastDigitNumber]);
 

  return (
    <div className="sm:px-[6%] md:py-10 sm:py-12 flex flex-wrap sm:flex-nowrap scroll-mt-0">
      <Card
        cardHeight={"auto"}
        isWhiteForSignup={appThemeData.isWhiteBgForCard}
        isDarkForKudzu={appThemeData.isDarkBgForCard}
        backgroundColor={"--modalcard-bg"}
        Cardcaption={t("prepaid_card_text")}
        header={true}
        footer={true}
        isForMobile={true}
        CardRadius={true}
        isLogo={isFromSmiOne ? true  : false}
        cardWidth ={'md:w-[65%] sm:w-[100%]'}
      >
        <div className="flex flex-col mt-28 md:w-[51%]"> 
          <CustomInput
            name="lastDigit"
            label={t("last_digit")} 
            register={register}
            error={errors.lastDigitNo}
            type="text"
            onChange={ (e)=>{
              const inputValue = e.target.value
              const formattedAmount =  handleAmountInputLimitTo2decimal(inputValue);
              dispatch({type: 'SMI_ONE_LAST_DIGIT_CARD_NO', payload: {smiOneLastDigitCardNo :formattedAmount}})
              setLastDigit(formattedAmount)
              // if(lastDigitNumber && lastDigitNumber.length === 4){
              //   setIsLastDigitEntered(true)
              // }else{
              //   setIsLastDigitEntered(false )
              // }
            }
            }
            value ={lastDigitNumber}
            maxLength={4}
            isErrorShow={true}
            isAutoFocus={true}
            isPasswordShow={true}
            showPasswordToggle
            isValid={isLastDigitEntered}
            autoFocus={true}
            onKeyDownFun={(event) => {
              if (event.key == "Enter") {
                event.preventDefault();
                handleLastDigitSabmit()
              }
            }}
            // ref={lastDigitRef}
          />
          {/* <CustomInput
            name="repeatPassword"
            label={t("Expiration_Date")}
            register={register}
            error={errors.repeatPassword}
            type="text"
            onChange={ (e)=>{
              const inputValue = e.target.value 
              setExpirationDate(inputValue)
            }
            }
            value ={expirationDate}
            isErrorShow={true}
            isPasswordShow={true}
            showPasswordToggle
            isValid={isRepeatPasswordValid}
            ref={repeatPasswordRef} // Assign the ref to the input field
            onKeyDownFun={(event) => {
              if (event.key == "Enter") {
                event.preventDefault(); 
              }
            }}
          /> */}
            {errorMessage &&
              <div className={` mb-2 pb-[2rem]`}>
                {displayErrorMessage(errorMessage)}
              </div>
            }
 
        </div>

        <div className="flex justify-between items-center mt-20 mb-24">
          <button
            type="button"
            className="font-hanken-grotesk sm:font-bold font-[600] lg:text-[16px] md:text-[16px] sm:text-[11px] text-[12px]
              text-[var(--twofac-modal-btn-clr-disabled)] cursor-pointer flex items-center"
            onClick={locateMyCardDetails} // Call handleContinue instead of openPhoneOTPModal directly
            
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault(); 
              }
            }}
          >
            {t("locate_my_card_text")}
             
          </button>
          <button
            type="button"
            className={`font-hanken-grotesk sm:font-bold font-[600] lg:text-[16px] md:text-[16px] sm:text-[11px] text-[12px]
              text-[var(--twofac-modal-btn-clr-disabled)] cursor-pointer flex items-center ${
                !isLastDigitEntered
                  ? "text-[var(--nextdrop-color)] opacity-55"
                  : "text-[var(--nextAct-color)]"
              }`}
              disabled={!isLastDigitEntered}
            onClick={handleLastDigitSabmit} 
            
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault(); 
                handleLastDigitSabmit()
              }
            }}
          >
            {t("continue")}
            <img
                src={
                  !isLastDigitEntered
                    ? appThemeData.NextArrowInactive
                    : appThemeData.RightArrowActive
                }
              className={`${
                signUpkudzuPlusTrue
                  ? ""
                  : " md:w-[17px] sm:w-[11px]  md:h-[17px] sm:h-[11px] w-[12px] h-[12px]"
              } ml-2`}
              alt="Arrow"
            />
          </button>
        </div>
      </Card>
      {isLoading && <Loader />}
    </div>
  );
};

export default SmiOneExpirationDateAndLastDigitCard;
